import React from 'react';
import TekMark from './TekMark';

/**
 * TekLoader — uses the existing TekHub mark, with a gentle breath pulse
 * and three sequential dots beneath.
 *
 * Props:
 *   size       — height of the mark in px (default 56)
 *   label      — optional caption below (e.g. "Loading workspace…")
 *   showDots   — whether to show pulsing dots (default true)
 *   wordmark   — show "ekHUB" wordmark beside the glyph (default true)
 *   className  — wrapper classes
 */
export default function TekLoader({
  size = 22,
  label,
  showDots = true,
  wordmark = true,
  className = '',
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label || 'Loading'}
      className={`tk-loader-root inline-flex flex-col items-center justify-center gap-3 ${className}`}
    >
      <span className="tk-loader-mark inline-flex">
        <TekMark size={size} wordmark={wordmark} />
      </span>

      {showDots && (
        <div className="tk-loader-dots flex items-center gap-1.5" aria-hidden>
          <span /><span /><span />
        </div>
      )}

      {label && (
        <span className="tk-loader-label" style={{ color: 'var(--ink-mute)' }}>
          {label}
        </span>
      )}
    </div>
  );
}

/** FullPageLoader — center-screen version with paper backdrop. */
export function FullPageLoader({ label = 'Loading…' }) {
  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center"
      style={{ background: 'var(--paper)' }}
    >
      <TekLoader size={22} label={label} />
    </div>
  );
}
